import { saveCustomer, getLocationDetailsService, switchUserLocationService } from "../../services/createCustomerService";
import { START_LOADING, STOP_LOADING } from "./actionTypes";

export const saveCustomerAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_CUSTOMER' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveCustomer(formData, token);

    if(response){
      callbackfn(response)
    }

    dispatch({ type:STOP_LOADING, service: 'SAVE_CUSTOMER' });
    dispatch({ type: "SAVE_CREATE_CUSTOMER", payload: response });

  } catch (error) {
    dispatch({
      type: "SAVE_CREATE_CUSTOMER_FAILURE",
      payload: error || 'Save task service failed. Please try again.'
    });
  }
};

export const getLocationAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_CUSTOMER' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getLocationDetailsService(token);

    dispatch({ type:STOP_LOADING, service: 'SAVE_CUSTOMER' });
    dispatch({ type: "GET_LOCATION_HEADER_SUCCESS", payload: response });

  } catch (error) {
    dispatch({
      type: "GET_LOCATION_FAILURE",
      payload: error || 'Save task service failed. Please try again.'
    });
  }
};

export const switchUserLocationAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_CUSTOMER' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await switchUserLocationService(token, id);

    dispatch({ type:STOP_LOADING, service: 'SAVE_CUSTOMER' });
    dispatch({ type: "SWITCH_USER_LOCATION_SUCCESS", payload: response });

  } catch (error) {
    dispatch({
      type: "SWITCH_USER_LOCATION_FAILURE",
      payload: error || 'Swtich user location service failed. Please try again.'
    });
  }
};
